import { HealthDataModal } from './HealthDataModal.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(HealthDataModal)
export { withUnmountHoc as HealthDataModal }
